// extracted by mini-css-extract-plugin
export default {"card":"QaG6782A","mainName":"KnZJDcUK","name":"CYXLaNnC","content":"fcHP7jVN","detailContent":"f9fhI01H","contentFlexElem":"RcUeBegQ","contentElem":"UVXN2LcQ"};
    if(module.hot) {
      // 1721070004622
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  